<template>
	<div class="gb-day gb-cell white--text lighten-1" tile :class="styleDay" :style="styleUnitDay">
		{{ day.day }}
	</div>
</template>
<script>
export default {
	name: 'GBDay',
	props:["day", "width"],
	computed: {
		styleDay: function() {
			let classes = new Array();
			if (this.day.isToday()) {
				classes.push("green");
			} else {
				classes.push("primary");
			}
			return classes;
		},
		styleUnitDay: function() {
			return {
				'width':  this.width + 'px',
			};
		},
	},
}
</script>
<style>
	.gb-day {
		display: inline-block;
		height: 100%;
		text-align: center;
	}
</style>
